import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const CURS = ["PLN", "EUR", "USD"];

export const InvoiceSettingsDialog = ({ open, onClose }) => {
  const [s, setS] = useState(null);
  useEffect(() => { if (open) api.get("/invoice-settings").then((r) => setS(r.data)).catch(() => {}); }, [open]);
  const setAcc = (c, k, v) => setS((x) => ({ ...x, accounts: { ...x.accounts, [c]: { ...x.accounts[c], [k]: v } } }));
  const save = async () => {
    try { await api.put("/invoice-settings", s); toast.success("Zapisano ustawienia faktur"); onClose(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Błąd zapisu"); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-xl max-h-[90vh] overflow-auto" data-testid="invoice-settings-dialog">
        <DialogHeader>
          <DialogTitle className="font-[Outfit]">Ustawienia faktur</DialogTitle>
          <DialogDescription>Rachunki bankowe Toren PATH sp. z o.o. dla każdej waluty.</DialogDescription>
        </DialogHeader>
        {s && (
          <div className="space-y-4">
            {CURS.map((c) => (
              <div key={c} className="border border-border rounded-md p-3 space-y-2" data-testid={`settings-account-${c}`}>
                <p className="text-sm font-semibold text-[#193962]">Konto {c}</p>
                <Input data-testid={`settings-iban-${c}`} placeholder="IBAN, np. PL61 1090 1014 0000 0712 1981 2874" value={s.accounts[c]?.iban || ""} onChange={(e) => setAcc(c, "iban", e.target.value)} />
                <div className="grid grid-cols-2 gap-2">
                  <Input data-testid={`settings-bank-${c}`} placeholder="Nazwa banku" value={s.accounts[c]?.bank_name || ""} onChange={(e) => setAcc(c, "bank_name", e.target.value)} />
                  <Input data-testid={`settings-swift-${c}`} placeholder="SWIFT/BIC" value={s.accounts[c]?.swift || ""} onChange={(e) => setAcc(c, "swift", e.target.value)} />
                </div>
              </div>
            ))}
            <div className="grid grid-cols-2 gap-3">
              <div className="col-span-2"><Label>E-mail księgowej (raport miesięczny 1. dnia miesiąca)</Label><Input type="email" data-testid="settings-accountant-email" value={s.accountant_email || ""} onChange={(e) => setS({ ...s, accountant_email: e.target.value })} placeholder="ksiegowa@biuro.pl" /></div>
              <div><Label>Domyślny termin płatności (dni)</Label><Input type="number" min={0} data-testid="settings-payment-days" value={s.payment_days} onChange={(e) => setS({ ...s, payment_days: Number(e.target.value) })} /></div>
              <div><Label>Miejsce wystawienia</Label><Input data-testid="settings-place" value={s.place} onChange={(e) => setS({ ...s, place: e.target.value })} /></div>
            </div>
            <Button onClick={save} data-testid="settings-save-btn" className="w-full bg-[#193962] text-white">Zapisz</Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
